import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between">
          {/* Logo - Clean Typography Only */}
          <div className="flex flex-col mb-4 md:mb-0">
            <span className="text-2xl font-bold text-white tracking-tight">LinearCal</span>
            <span className="text-sm text-gray-400 font-normal">The Intelligent Calendar</span>
          </div>
          
          {/* Copyright */}
          <div className="text-gray-400 text-sm">
            © 2025 LinearCal. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
